
    import './styles.scoped.css';
    export default {
  "block-body-scroll": "_block-body-scroll_5xden_3",
  "mobile-bar": "_mobile-bar_5xden_7",
  "mobile-bar-breadcrumbs": "_mobile-bar-breadcrumbs_5xden_20",
  "mobile-toggle": "_mobile-toggle_5xden_27"
};
  